import React from 'react'
import { PageTitle } from 'src/components/PageTitle'
import ROUTES from 'src/constants/routes'
import { useStyles } from '../styles'

interface BreedingHeaderProps {
  isLoading?: boolean
}

export const BreedingHeader: React.FC<BreedingHeaderProps> = () => {
  const style = useStyles()

  return (
    <div className={style.propertiesHeader}>
      <PageTitle
        title='Detalhes da Reprodução'
        className={style.propertiesTitle}
        breadcrumbLink={{
          to: ROUTES.REPRODUCTION.PREGNANCY_LIST,
          text: 'Lista de Reprodução'
        }}
      />
    </div>
  )
}
